export default {
	InvitationCode: "Meghívókód",
	CreditScore: "Hitelminősítés",
	MyFinancial: {
		title: "Pénzügyeim",
		menu: ["Befizetés", "Kifizetés", "Tranzakció"]
	},
	MyDetail: {
		title: "Saját adataim",
		menu: ["Személyes adatok", "Fizetési módok"]
	},
	Other: {
		title: "Egyéb",
		menu: ["Kapcsolatfelvétel", "Értesítések", "Nyelv megváltoztatása"]
	},
	Amount: ["Pénztárca Egyenleg", "Zárolt Egyenleg", "Mai Jövedelem"],
	Logout: {
		title: "Kijelentkezés",
		content: "Biztosan kijelentkezik?"
	}
};
